import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogPaper
} from '@/modules/components/ui/dialog'
import { ComponentPropsWithoutRef } from 'react'

export const ErrorViewDialog = ({
  ...rest
}: ComponentPropsWithoutRef<typeof Dialog>) => {
  return (
    <Dialog {...rest}>
      <DialogContent>
        <DialogClose />
        <DialogPaper className='box-border max-w-[335px] md:max-w-[615px] lg:max-w-[700px] mx-auto text-center'>
          <p className='text-[30px] md:text-[50px] font-medium leading-[1] tracking-[-0.04em] mb-[16px] md:mb-[24px]'>
            Не удалось отправить заявку
          </p>
          <p className='max-w-[550px] mx-auto leading-[120%]'>
            Произошла ошибка на сервере.
            <br />
            Пожалуйста, попробуйте обновить страницу и отправить заявку повторно
            или свяжитесь с нами по телефону <br />
            <a href='tel:+7(800)333-71-38' className='font-medium'>
              8 (800) 444-81-38
            </a>
          </p>
        </DialogPaper>
      </DialogContent>
    </Dialog>
  )
}
